import React from 'react';
import Guitar from '../guitar';

const FeaturedGuitar = props => {
  if (props.guitar)
    return (
      <div>
        <div className="row featuredGuitar">
          <h3 className="col-md-12 text-center">Featured guitar</h3>
        </div>
        <Guitar guitar={props.guitar} />
      </div>
    );
  return <div>No featured guitar at this time</div>;
};

export default FeaturedGuitar;



// WEBPACK FOOTER //
// ./src/main-page/featured-guitar.js